// extracted by mini-css-extract-plugin
export var datenLinksContainer = "datenlinks-module--datenLinksContainer--Q5zhB";
export var datenLink = "datenlinks-module--datenLink--6HwOq";